import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import { scrollReveal, scrollRevealStagger } from "./directives/scrollReveal";
import "./styles/tailwind.css";

const app = createApp(App);

app.directive("scroll-reveal", scrollReveal);
app.directive("scroll-reveal-stagger", scrollRevealStagger);

app.use(router).use(i18n).mount("#app");
